import { useQuery } from 'react-query';

import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import useGetFetchConfig from '@/api/useGetFetchConfig';

export interface RelativityFilterField {
  fieldName: string;
  fieldType: string;
  displayName: string;
}

export interface RelativityFilterOptionsRes {
  fields: RelativityFilterField[];
  availableOptions: Record<string, string[]>;
}

export const useGetRelativityFilterOptions = ({ matterId }: { matterId: string | null }) => {
  const { fetchConfigGET } = useGetFetchConfig();

  return useQuery<RelativityFilterOptionsRes>(
    [QueryEntity.RelativityFilterOptions, { matterId }],
    async () => {
      const res = await fetch(
        `${APIBaseChronos}/api/matters/${matterId}/relativity-filter-options`,
        fetchConfigGET,
      );
      if (!res.ok) {
        throw new Error('Failed to fetch relativity filter options');
      }
      return res.json();
    },
    {
      enabled: !!matterId,
      refetchOnWindowFocus: false,
    },
  );
};
